const CUSTOMER_MAPPING_ELI_LILLY = { label: 'Eli Lilly', icon: 'eli-lilly' };
const CUSTOMER_MAPPING_REAXYS = { label: 'Elsevier Reaxys', icon: 'reaxys-icon' };
// iconSize, iconOffsetX, and iconOffsetY are used when the icon is rendered in the route-tree SVG.
const CUSTOMER_MAPPING_BOEHRINGER = { label: 'Boehringer', icon: 'boehringer', iconSize: 24, iconOffsetX: 4, iconOffsetY: 36 };
const CUSTOMER_MAPPING_UCB = { label: 'UCB', icon: 'ucb', iconSize: 24, iconOffsetX: 4, iconOffsetY: 36 };
const CUSTOMER_MAPPING_UCB_BE = { ...CUSTOMER_MAPPING_UCB, icon: 'ucb-be' };
const CUSTOMER_MAPPING_UCB_UK = { ...CUSTOMER_MAPPING_UCB, icon: 'ucb-uk' };

export const CUSTOMER_LIBRARY_NAMES_AND_ICONS_MAPPING = {
  UCB_BE: CUSTOMER_MAPPING_UCB_BE,
  UCB_UK: CUSTOMER_MAPPING_UCB_UK,
};

/**
 * Maps the department IDs returned in customerInfo.name to customer icon metadata.
 * The application build is environment-agnostic, so this includes both non-production
 * and production customer department IDs.
 */
const CUSTOMER_DEPARTMENT_IDS_AND_ICONS_MAPPING = {
  // Nonprod
  // VIP-PAI
  1005626: CUSTOMER_MAPPING_REAXYS,
  // VIP-Iktos
  1005627: CUSTOMER_MAPPING_REAXYS,

  // Prod
  // elililly-iktos
  176887: CUSTOMER_MAPPING_ELI_LILLY,
  249259: CUSTOMER_MAPPING_ELI_LILLY,
  294063: CUSTOMER_MAPPING_ELI_LILLY,
  37768: CUSTOMER_MAPPING_ELI_LILLY,
  483877: CUSTOMER_MAPPING_ELI_LILLY,
  815511: CUSTOMER_MAPPING_ELI_LILLY,
  944027: CUSTOMER_MAPPING_ELI_LILLY,
  959938: CUSTOMER_MAPPING_ELI_LILLY,
  976274: CUSTOMER_MAPPING_ELI_LILLY,
  993065: CUSTOMER_MAPPING_ELI_LILLY,
  990610: CUSTOMER_MAPPING_ELI_LILLY,

  // boehringer-iktos
  262218: CUSTOMER_MAPPING_BOEHRINGER,
  293373: CUSTOMER_MAPPING_BOEHRINGER,
  981174: CUSTOMER_MAPPING_BOEHRINGER,
  990042: CUSTOMER_MAPPING_BOEHRINGER,

  // ucb_pai
  1003631: CUSTOMER_MAPPING_UCB,
  957543: CUSTOMER_MAPPING_UCB,
  965338: CUSTOMER_MAPPING_UCB,
  975830: CUSTOMER_MAPPING_UCB,
};

export default CUSTOMER_DEPARTMENT_IDS_AND_ICONS_MAPPING;
